import { add, round } from '@/libs/util.number'

function buildEditContainerGoodsColumns(columns = [], isGrouping = false) {
  return columns.map((column) => {
    if (column.field !== 'containerBoxQty') return { ...column }

    return {
      ...column,
      width: isGrouping
        ? Number(column.width || column.minWidth || 100)
        : column.width,
      minWidth: column.minWidth,
      treeNode: false,
      slots: { default: 'containerBoxQty' },
    }
  })
}

function getEditContainerGoodsGroupMetrics(rows = []) {
  const metrics = rows.reduce(
    (result, row) => {
      result.groupBoxQty = add(result.groupBoxQty, row.containerBoxQty || 0)
      result.groupGoodsQty = add(
        result.groupGoodsQty,
        row.containerGoodsQty || 0
      )
      result.groupVolume = add(result.groupVolume, row.totalVolume || 0)
      result.groupWeight = add(
        result.groupWeight,
        row.totalGrossWeight || 0
      )
      return result
    },
    {
      groupCount: rows.length,
      groupBoxQty: 0,
      groupGoodsQty: 0,
      groupVolume: 0,
      groupWeight: 0,
    }
  )

  return {
    groupCount: metrics.groupCount,
    groupBoxQty: round(metrics.groupBoxQty, 2),
    groupGoodsQty: round(metrics.groupGoodsQty, 2),
    groupVolume: round(metrics.groupVolume, 2),
    groupWeight: round(metrics.groupWeight, 2),
  }
}

function getEditContainerGoodsGroupSpan({ row, column, columns = [] }) {
  if (!row || !row._isGroup) return null
  if (column.type === 'seq') return null
  if (column.type === 'checkbox') return null
  if (column.fixed === 'right') return null

  if (column.property === 'containerBoxQty') {
    const colspan = columns.filter(
      (item) =>
        item.type !== 'seq' &&
        item.fixed !== 'right' &&
        !item.fixed &&
        item.visible !== false
    ).length

    return { rowspan: 1, colspan: colspan || 1 }
  }

  return { rowspan: 0, colspan: 0 }
}

export {
  buildEditContainerGoodsColumns,
  getEditContainerGoodsGroupMetrics,
  getEditContainerGoodsGroupSpan,
}
